export const userLoginReducer = (state = {  }, action) => {
    switch(action.type){
        case 'USER_LOGIN_PENDING':
            return { loading: true } 
        case 'USER_LOGIN_SUCCESS':
            return { loading: false, userDetails: action.payload }
        case 'USER_LOGIN_FAILED':
            return {loading:false, error: action.payload}
        case 'USER_LOGOUT':
            return {}
        default:
            return state
    }

}

export const userProfileReducer = (state = { profile:{} }, action) => {
    switch(action.type){
        case 'PROFILE_REQUEST':
            return { ...state, loading: true } 
        case 'PROFILE_SUCCESS':
            return { loading: false, profile: action.payload }
        case 'PROFILE_LOGOUT':
            return {loading:false, error: action.payload}
        default:
            return state
    }
}